import { IconButton } from '@doordash/component-button'
import Pagination from '@doordash/component-pagination'
import { Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactSwipe from 'react-swipe'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { Direction, SlideButtons, SlideDecks } from '../../../typeModules/slide'
import { SlideType } from './slide-decks'

const IMG_WIDTH = 250

type HowToDashProps = {
  slides: SlideType[]
  deck: SlideDecks
}

type ReduxProps = {
  trackHowToDashNavigated?: (data: DA.SlideEvents) => Promise<any>
}

import {
  ContentContainer,
  Slide,
  SlideButtonWrapper,
  SlideWrapper,
  Wrapper,
  ImageContainer,
} from './styles'

const onSwiped = (
  idx: number,
  slideIndex: number,
  slides: SlideType[],
  deck: SlideDecks,
  isClicked: boolean,
  trackHowToDashNavigated: (data: DA.SlideEvents) => Promise<any>
) => {
  const toSlide = idx + 1

  trackHowToDashNavigated({
    deck,
    slide: toSlide,
    title: slides[idx].title,
    direction: toSlide > slideIndex ? Direction.Forward : Direction.Back,
    button: isClicked ? SlideButtons.Next : undefined,
    action: isClicked ? DA.EventActions.Clicked : DA.EventActions.Swiped,
  })
}

export const HowToDash: React.FC<HowToDashProps & ReduxProps> = ({
  slides,
  deck,
  trackHowToDashNavigated,
}) => {
  const [slideIndex, setSlideIndex] = React.useState<number>(0)
  const [isClicked, setIsClicked] = React.useState<boolean>(true)
  const [reactSwipeEl, setReactSwipeEl] = React.useState<ReactSwipe>(null)

  const count = slides.length

  return (
    <Wrapper>
      <ReactSwipe
        swipeOptions={{
          continuous: false,
          startSlide: slideIndex,
          callback: idx => {
            onSwiped(
              idx,
              slideIndex,
              slides,
              deck,
              isClicked,
              trackHowToDashNavigated
            )
          },
          transitionEnd: idx => setSlideIndex(idx),
        }}
        ref={ref => setReactSwipeEl(ref)}
      >
        {slides.map(slide => (
          <Slide key={slide.title}>
            <SlideWrapper>
              <Text styles={Text.Styles.PageTitle}>{slide.title}</Text>
              <Text
                textAlign={Text.TextAlignments.Center}
                styles={Text.Styles.SectionSubtext}
              >
                {slide.description}
              </Text>
              <ContentContainer>
                <SlideButtonWrapper>
                  <IconButton
                    isDisabled={slideIndex === 0}
                    type={IconButton.Types.Secondary}
                    iconType={IconButton.IconTypes.ArrowLeft}
                    size={IconButton.Sizes.Large}
                    accessibilityLabel={'arrow_left'}
                    onClick={() => {
                      setIsClicked(true)
                      reactSwipeEl.prev()
                    }}
                  />
                </SlideButtonWrapper>
                <ImageContainer>
                  <img width={IMG_WIDTH} src={slide.url} alt={slide.alt} />
                </ImageContainer>
                <SlideButtonWrapper>
                  <IconButton
                    isDisabled={slideIndex >= slides.length - 1}
                    type={IconButton.Types.Secondary}
                    iconType={IconButton.IconTypes.ArrowRight}
                    accessibilityLabel={'arrow_right'}
                    size={IconButton.Sizes.Large}
                    onClick={() => {
                      setIsClicked(true)
                      reactSwipeEl.next()
                    }}
                  />
                </SlideButtonWrapper>
              </ContentContainer>
            </SlideWrapper>
          </Slide>
        ))}
      </ReactSwipe>

      <Pagination
        accessibilityLabel={'Pagination'}
        indicatorAccessibilityLabelPrefix={'Pagination'}
        count={count}
        selectedIndex={slideIndex}
        onSelect={idx => setSlideIndex(idx)}
      />
    </Wrapper>
  )
}

const mapDispatchToProps = {
  trackHowToDashNavigated: events.trackHowToDashNavigated,
}

export default connect(null, mapDispatchToProps)(HowToDash)
